export default {
  createFrom: function (urlParams) {
    const zoomParameter = Number(urlParams.get('zoom'))
    let xParameter = Number(urlParams.get('x'))
    let yParameter = Number(urlParams.get('y'))

    return {
      zoom: zoomParameter,
      x: xParameter,
      y: yParameter,
      available: !!(zoomParameter && xParameter && yParameter)
    }
  }
}
